import React from 'react';

const AlertOutline = ({ size = 24, color = '#8D91A0', onClick }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_633_425)'>
        <path d='M24 0H0V24H24V0Z' fill='white' fillOpacity='0.01' />
        <path
          d='M12 22C14.7614 22 17.2614 20.8807 19.0711 19.0711C20.8807 17.2614 22 14.7614 22 12C22 9.2386 20.8807 6.7386 19.0711 4.92893C17.2614 3.11929 14.7614 2 12 2C9.2386 2 6.7386 3.11929 4.92893 4.92893C3.11929 6.7386 2 9.2386 2 12C2 14.7614 3.11929 17.2614 4.92893 19.0711C6.7386 20.8807 9.2386 22 12 22Z'
          stroke={color}
          strokeWidth='1.6'
          strokeLinejoin='round'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.0002 18.0764C12.4567 18.0764 12.8267 17.7063 12.8267 17.2499C12.8267 16.7934 12.4567 16.4233 12.0002 16.4233C11.5438 16.4233 11.1737 16.7934 11.1737 17.2499C11.1737 17.7063 11.5438 18.0764 12.0002 18.0764Z'
          fill={color}
        />
        <path
          d='M12 6V14'
          stroke={color}
          strokeWidth='1.6'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_633_425'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlertOutline;
